import type { Toast } from './types'

export const getDirection = (position: Toast['position']) => {
  if (position === 'topCenter') {
    return 'down'
  }

  return 'left'
}
